import { Box, Grid, Typography } from '@mui/material';
import Diia from '../icons/Diia.tsx';
import Arrow from '../icons/Arrow.tsx';
import Video from '../icons/Video.tsx';
import { styles } from './styles';
import { ClientTypes } from '~/constants/clientTypes.ts';

interface ISelectVerificationMethodProps {
  isDiiaVerification: boolean;
  isVideoVerification: boolean;
  handleDiiaVerification: () => void;
  handleVideoVerification: () => void;
  clientType?: string;
}

export const SelectVerificationMethod = ({
  isDiiaVerification = true,
  isVideoVerification = true,
  handleDiiaVerification,
  handleVideoVerification,
  clientType,
}: ISelectVerificationMethodProps) => {
  const bothVisible = isDiiaVerification && isVideoVerification;
  const gridSize = { xs: 12, sm: 12, md: bothVisible ? 6 : 12 };

  return (
    <>
      <Typography variant="h2">Підтвердження особи</Typography>
      {clientType === ClientTypes.LEGAL_RESIDENT && (
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant={'body1'}>
            <Typography component="span" sx={styles.infoText}>
              Важливо!
            </Typography>{' '}
            Верифікацію має пройти{' '}
            <Typography component="span" sx={styles.infoText}>
              керівник юридичної особи
            </Typography>
          </Typography>
          <Typography variant={'body1'}>
            Якщо верифікацію пройде інша особа - підписання заявки буде неможливим.
          </Typography>
        </Box>
      )}
      <Grid container sx={{ display: 'flex' }} spacing={3}>
        {isDiiaVerification && (
          <Grid size={gridSize} sx={styles.card}>
            <Box
              sx={styles.cardTopContainer}
              onClick={handleDiiaVerification}
              data-testid="verification_diia_button"
            >
              <Diia />
              <Box sx={styles.cardTopTextContainer}>
                <Typography variant="h4" noWrap>
                  Верифікація через Дію
                </Typography>
                <Typography>Без участі менеджера</Typography>
              </Box>
              <Arrow />
            </Box>
            <Box sx={styles.cardBottomTextContainer}>
              <Typography>
                Необхідний застосунок Дія на смартфоні з ID-карткою або закордонним паспортом
              </Typography>
              <Typography>Необхідний Дія.Підпис</Typography>
            </Box>
          </Grid>
        )}
        {isVideoVerification && (
          <Grid size={gridSize} sx={styles.card}>
            <Box
              sx={styles.cardTopContainer}
              onClick={handleVideoVerification}
              data-testid="verification_video_button"
            >
              <Video />
              <Box sx={styles.cardTopTextContainer}>
                <Typography variant="h4">Відеоверифікація</Typography>
                <Typography>За участю менеджера</Typography>
              </Box>
              <Arrow />
            </Box>
            <Box sx={styles.cardBottomTextContainer}>
              <Typography>
                Необхідна камера на телефоні або комп'ютері для відеозв'язку з працівником банку
              </Typography>
              <Typography>Необхідний КЕП будь-якого АЦСК</Typography>
            </Box>
          </Grid>
        )}
      </Grid>
    </>
  );
};
